/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Button, Divider, Flex, Text } from "@aws-amplify/ui-react";
export default function Toolbar(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: {
        "Filtro:": {},
        ButtonLeft: {},
        Title: {},
        ButtonUno: {},
        Divider38491538: {},
        ButtonDos: {},
        Divider38491541: {},
        ButtonTres: {},
        Divider38491565: {},
        ButtonCuatro: {},
        Divider46215981: {},
        ButtonCinco: {},
        "Frame 20849": {},
        Buttons: {},
        Toolbar: {},
      },
      variantValues: { type: "mesa" },
    },
    {
      overrides: {
        "Filtro:": { display: "none" },
        ButtonLeft: { children: "CREAR LEAD" },
        Title: {},
        ButtonUno: { children: "POR ASIGNAR" },
        Divider38491538: {},
        ButtonDos: { children: "ASIGNADO" },
        Divider38491541: {},
        ButtonTres: { children: "DESCARTADO" },
        Divider38491565: { display: "none" },
        ButtonCuatro: { display: "none" },
        Divider46215981: {},
        ButtonCinco: {},
        "Frame 20849": {},
        Buttons: {},
        Toolbar: {},
      },
      variantValues: { type: "lead" },
    },
    {
      overrides: {
        "Filtro:": { display: "none" },
        ButtonLeft: { display: "none", children: "CREAR LEAD" },
        Title: {},
        ButtonUno: { children: "POR ASIGNAR" },
        Divider38491538: {},
        ButtonDos: { children: "ASIGNADO" },
        Divider38491541: {},
        ButtonTres: { children: "DESCARTADO" },
        Divider38491565: {},
        ButtonCuatro: { children: "SEGUIMIENTO" },
        Divider46215981: {},
        ButtonCinco: {},
        "Frame 20849": { display: "none" },
        Buttons: {},
        Toolbar: {},
      },
      variantValues: { type: "leadmanager" },
    },
    {
      overrides: {
        "Filtro:": { display: "none" },
        ButtonLeft: { display: "none", children: "CREAR LEAD" },
        Title: {},
        ButtonUno: { children: "POR ASIGNAR" },
        Divider38491538: {},
        ButtonDos: { children: "ASIGNADO" },
        Divider38491541: {},
        ButtonTres: { children: "DESCARTADO" },
        Divider38491565: {},
        ButtonCuatro: { children: "SEGUIMIENTO" },
        Divider46215981: {},
        ButtonCinco: {},
        "Frame 20849": {},
        Buttons: {},
        Toolbar: {},
      },
      variantValues: { type: "leadleader" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="12px"
      direction="row"
      width="1200px"
      height="unset"
      justifyContent="flex-start"
      alignItems="center"
      position="relative"
      boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
      borderRadius="4px"
      padding="12px 24px 12px 24px"
      backgroundColor="rgba(39,45,93,1)"
      display="flex"
      {...getOverrideProps(overrides, "Toolbar")}
      {...rest}
    >
      <Flex
        gap="12px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        grow="1"
        shrink="1"
        basis="0"
        position="relative"
        padding="0px 0px 0px 0px"
        display="flex"
        {...getOverrideProps(overrides, "Title")}
      >
        <Text
          fontFamily="Inter"
          fontSize="16px"
          fontWeight="400"
          color="rgba(255,255,255,1)"
          lineHeight="24px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          letterSpacing="0.01px"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Filtro:"
          {...getOverrideProps(overrides, "Filtro:")}
        ></Text>
        <Button
          width="unset"
          height="unset"
          shrink="0"
          size="default"
          isDisabled={false}
          variation="primary"
          children="CRÉDITOS ACTIVOS"
          {...getOverrideProps(overrides, "ButtonLeft")}
        ></Button>
      </Flex>
      <Flex
        gap="12px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        display="flex"
        {...getOverrideProps(overrides, "Buttons")}
      >
        <Button
          width="unset"
          height="unset"
          shrink="0"
          size="default"
          isDisabled={false}
          variation="primary"
          children="ASESOR"
          {...getOverrideProps(overrides, "ButtonUno")}
        ></Button>
        <Divider
          height="33px"
          shrink="0"
          size="small"
          orientation="vertical"
          {...getOverrideProps(overrides, "Divider38491538")}
        ></Divider>
        <Button
          width="unset"
          height="unset"
          shrink="0"
          size="default"
          isDisabled={false}
          variation="primary"
          children="GERENTE"
          {...getOverrideProps(overrides, "ButtonDos")}
        ></Button>
        <Divider
          height="33px"
          shrink="0"
          size="small"
          orientation="vertical"
          {...getOverrideProps(overrides, "Divider38491541")}
        ></Divider>
        <Button
          width="unset"
          height="unset"
          shrink="0"
          size="default"
          isDisabled={false}
          variation="primary"
          children="VERIFICADOR"
          {...getOverrideProps(overrides, "ButtonTres")}
        ></Button>
        <Divider
          height="33px"
          shrink="0"
          size="small"
          orientation="vertical"
          {...getOverrideProps(overrides, "Divider38491565")}
        ></Divider>
        <Button
          width="unset"
          height="unset"
          shrink="0"
          size="default"
          isDisabled={false}
          variation="primary"
          children="M.CONTROL"
          {...getOverrideProps(overrides, "ButtonCuatro")}
        ></Button>
        <Flex
          gap="12px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          display="flex"
          {...getOverrideProps(overrides, "Frame 20849")}
        >
          <Divider
            height="33px"
            shrink="0"
            size="small"
            orientation="vertical"
            {...getOverrideProps(overrides, "Divider46215981")}
          ></Divider>
          <Button
            width="unset"
            height="unset"
            shrink="0"
            size="default"
            isDisabled={false}
            variation="primary"
            {...getOverrideProps(overrides, "ButtonCinco")}
          ></Button>
        </Flex>
      </Flex>
    </Flex>
  );
}
